import { render, staticRenderFns } from "./TFooter.vue?vue&type=template&id=0208ef0f&scoped=true"
import script from "./TFooter.vue?vue&type=script&lang=js"
export * from "./TFooter.vue?vue&type=script&lang=js"
import style0 from "./TFooter.vue?vue&type=style&index=0&id=0208ef0f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0208ef0f",
  null
  
)

export default component.exports